var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "billingAddress" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.shippingAddress,
            expression: "shippingAddress"
          }
        ]
      },
      [
        _c("div", { attrs: { id: "billingAddressSame" } }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.isSameAddress,
                expression: "isSameAddress"
              }
            ],
            attrs: { id: "isSameAddress", type: "checkbox" },
            domProps: {
              checked: Array.isArray(_vm.isSameAddress)
                ? _vm._i(_vm.isSameAddress, null) > -1
                : _vm.isSameAddress
            },
            on: {
              change: function($event) {
                var $$a = _vm.isSameAddress,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.isSameAddress = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.isSameAddress = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.isSameAddress = $$c
                }
              }
            }
          }),
          _vm._v(" "),
          _c("label", { attrs: { for: "isSameAddress" } }, [
            _vm._v("Utiliser la même adresse comme adresse de facturation")
          ])
        ]),
        _vm._v(" "),
        _vm.address && !_vm.isSameAddress
          ? _c("div", [
              _c(
                "span",
                {
                  staticClass: "btn btn-secondary edit-address btnEdit",
                  staticStyle: { top: "30px" },
                  on: { click: _vm.edit }
                },
                [_vm._v("Modifier mon adresse")]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "headerTitle" }, [
                _vm._v("Adresse de facturation")
              ]),
              _vm._v(" "),
              _c("div", { attrs: { id: "billingAddressSelected" } }, [
                _c("ul", [
                  _c("li", { attrs: { id: "billingAddressTitle" } }, [
                    _vm._v(_vm._s(_vm.address.title))
                  ]),
                  _vm._v(" "),
                  _c("li", { attrs: { id: "billingAddressNames" } }, [
                    _vm._v(
                      _vm._s(_vm.address.firstname) +
                        " " +
                        _vm._s(_vm.address.lastname)
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", { attrs: { id: "billingAddressAddress" } }, [
                    _vm._v(
                      _vm._s(_vm.address.number) +
                        " " +
                        _vm._s(_vm.address.address1)
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", { attrs: { id: "billingAddressCountry" } }, [
                    _vm._v(
                      _vm._s(_vm.address.zipcode) +
                        " " +
                        _vm._s(_vm.address.country.name)
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", { attrs: { id: "billingAddressPhone" } }, [
                    _c("i", { staticClass: "fa fa-phone" }),
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.address.phone) +
                        "\n                    "
                    )
                  ])
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isSameAddress && !_vm.address && !_vm.isLoading,
                expression: "!isSameAddress && !address && !isLoading"
              }
            ],
            staticClass: "mt-4"
          },
          [
            _c(
              "form",
              {
                attrs: {
                  id: "billingAddressForm",
                  name: "billingAddress",
                  method: "post",
                  novalidate: "novalidate",
                  autocomplete: "off"
                },
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    _vm.billingAddressSubmit($event)
                  }
                }
              },
              [_vm._t("billingAddressForm"), _vm._v(" "), _vm._m(0)],
              2
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "ponroy-order-addresses-modal",
          {
            attrs: {
              id: "billingAddressesBookModal",
              "form-name": "billingAddressModal",
              "slot-name": "billingAddressModalForm",
              type: "billing"
            }
          },
          [
            _vm._t("billingAddressModalForm", null, {
              slot: "billingAddressModalForm"
            })
          ],
          2
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-primary",
          attrs: { id: "billingAddressSubmit", type: "submit" }
        },
        [_vm._v("Valider")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-931bb37c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-931bb37c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/SiteBundle/Resources/assets/components/Order/OrderBillingAddress.vue
// module id = 550
// module chunks = 1